import moment from 'moment';
import { ReportDto } from '@/core';

export const getMonthOfLastGeneratedReport = (reports: ReportDto[]) => {
  const reportsCopy = [...reports];
  const lastReport = reportsCopy
    .filter((report) => report.isDataSource)
    .sort((a, b) => moment(b.metricsDate).diff(moment(a.metricsDate)))
    .at(0);
  return moment(lastReport?.metricsDate).format("MMMM'YY");
};
